@if (guest.status === STATUS_PENDING || guest.status === STATUS_DECLINED) {
  <raised-button
    (click)="accept()"
    color="primary"
    >
    Accept
  </raised-button>
}
&nbsp;
@if (guest.status === STATUS_PENDING || guest.status === STATUS_CONFIRMED) {
  <raised-button
    (click)="decline()"
    color="warn"
    >
    Decline
  </raised-button>
}
